export enum AccountRolesEnum {
  USER = 'user',
  ADMIN = 'admin',
}

export enum RolesEnum {
  USER = 'user',
  ADMIN = 'admin',
}
